export default "__VITE_ASSET__COwJMS0w__"